import { Typography } from "@mui/material";
import { useEffect } from "react";
import { Loading } from "../../components/Loading";
import { RootState, useAppDispatch, useAppSelector } from "../../redux";
import { getBatchesOpen } from "../../redux/slices/batches";
import { ListCard } from "./components";

export const WorkCenter = () => {
    const dispatch = useAppDispatch();
    const { isLoading, batchesGrouped = [] } = useAppSelector((state: RootState) => state.batches);

    useEffect(() => {
        dispatch(getBatchesOpen() as any);
    }, [dispatch])

    return (
        <div>
            <Loading isLoading={isLoading} />
            <Typography variant="h4" component="h1">Work Center</Typography>
            <br />
            <ListCard batchesGrouped={batchesGrouped} />
        </div>
    )
}